import { Separator } from "@shortsworks/ui";
import { useMainContext } from "@app/components/MainContainer";
import { PropsWithChildren, ReactNode } from "react";

interface MainHeaderProps extends PropsWithChildren {
  className?: string;
}

export const MainHeader = ({ className, children }: MainHeaderProps) => {
  useMainContext();

  return (
    <div className="flex flex-col flex-shrink-0 space-y-6 p-4 lg:p-6 pb-0 lg:pb-0">
      <div className="space-y-0.5">{children}</div>
      <Separator />
    </div>
  );
};
